import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  FormGroup,
  FormControl,
  ShopifyResourcePicker,
  Button,
  ButtonSelect,
  Input,
  ProductSelector,
  ImagePicker,
  Modal,
  Carousel,
  RichEditor,
  Alert,
  ColorPicker
} from "components";
import {
  ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS,
  ONE_CHECK_UP_SELL_PRODUCT_REDUCER,
  PRESET_HIDDEN_PRODUCTS,
  CAMPAIGN_TYPES,
  BREAK_POINTS
} from "lib/globals";
import { API } from "aws-amplify";
import styles from "styles/campaign_settings_second_step.module.scss";
import { CartContext } from "components/cart";
import ShopContext from "context/ShopContext";
import classNames from "lib/classNames";
import useRefState from "hooks/useRefState";

const OneCheckUpSell = ({ context, validationErrors }) => {
  const { state: campaign, setItem, updateOldOCU } = context;
  const shopContext = useContext(ShopContext);
  const {
    state: {
      settings: { theme },
      currency
    }
  } = shopContext;
  const [hiddenProducts, setHiddenProducts] = useState([]);
  const newHiddenProductDefault = { title: "", image: "", price: "" };
  // const [newHiddenProduct, setNewHiddenProduct, newHiddenProductRef] = useRefState(newHiddenProductDefault);
  const [newHiddenProductLoading, setNewHiddenProductLoading] = useState(false);
  const [productsFetchLoading, setProductsFetchLoading] = useState(true);
  const [showHiddenProductSelector, setShowHiddenProductSelector] =
    useState(false);
  const [activeTab, setActiveTab] = useState(0);
  // const setProp = (value) => setNewHiddenProduct(Object.assign({}, newHiddenProduct, value));

  const [productImage, setProductImage] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [bodyHtml, setBodyHtml] = useState("");

  const setProps = (id) => {
    const selected = PRESET_HIDDEN_PRODUCTS.find((p) => p.id === id);
    setProductImage(selected.image);
    setProductTitle(selected.title);
    setProductPrice(selected.price);
    setBodyHtml(selected.body_html);
  };
  const createProduct = (setActiveTab) => {
    if (
      productImage === "" ||
      productTitle === "" ||
      productPrice === "" ||
      bodyHtml === ""
    )
      return;
    setNewHiddenProductLoading(true);
    API.post("API_GATEWAY_NEW", "/products", {
      body: {
        price: productPrice,
        title: productTitle,
        image: productImage,
        body_html: bodyHtml
      }
    })
      .then(({ product }) => {
        setHiddenProducts(hiddenProducts.concat([product]));
        setProductImage("");
        setProductTitle("");
        setProductPrice("");
        setBodyHtml("");
        setActiveTab(0);
        setNewHiddenProductLoading(false);
      })
      .catch(console.log);
  };

  useEffect(() => {
    setProductsFetchLoading(true);
    API.get("API_GATEWAY_NEW", "/products", {
      queryStringParameters: {
        type: "hidden",
        limit: 4
      }
    })
      .then(({ products }) => {
        setHiddenProducts(products);
        setProductsFetchLoading(false);
      })
      .catch(console.log);
  }, []);

  // useEffect(() => {
  // 	console.log(!!Object.values(newHiddenProduct).filter((value) => value === '').length || bodyHtml === '');
  // }, [newHiddenProduct, bodyHtml]);

  return (
    <>
      <FormGroup
        label={CAMPAIGN_TYPES["one_check_up_sell"]}
        info="Create a tick box that adds a little extra product to the cart."
      >
        <Alert type="info" icon="info-circle" className="mb-6" title="New one tick upsell version is now available" actions={[{
          text: "update",
          onClick: updateOldOCU
        }]} />
        <FormControl
          label="Ticked by default"
          info="When campaign is active it will auto tick the box and add one tick upsell product to the cart."
          withSwitch={[
            context,
            "settings.one_check_up_sell.is_ticked_by_default"
          ]}
          disabled
        >
          <div>
            <a
              href="https://monsterapps.crisp.help/en/article/auto-select-tick-box-deprecated-15wrgud/"
              target="_blank"
              rel="noopener noreferrer"
              className={classNames("underline text-sm font-medium")}
            >
              Learn more
            </a>
          </div>
          {/* <div className={classNames("border border-orange-100 rounded-lg p-4 mt-2 mb-6")} style={{ backgroundColor: "#FFF2E2" }}>
              <div className={classNames("flex")}>
                  <div className={classNames("flex-shrink-0")}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" className={classNames("h-5 w-5")}>
                          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566M8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                      </svg>
                  </div>
                  <div className={classNames("ml-3")}>
                      <h3 className={classNames("text-sm font-medium")}>
                          We have removed "Ticked by default"
                      </h3>
                      <div className={classNames("mt-1 text-sm")}>
                          <p>
                              To provide more trustworthy buyer experiences, Shopify is prohibiting apps from automatically adding non-free items. Buyers will need to explicitly accept add-ons by clicking the toggle. To learn more, see{' '}
                              <a 
                                  href="https://shopify.dev/docs/apps/launch/app-requirements-checklist#1-prohibited-and-restricted-app-configurations"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classNames("underline")}
                              >
                                  Section 1.19
                              </a>
                              {' '}of Shopify's app requirements.
                          </p>
                      </div>
                  </div>
              </div>
          </div> */}
        </FormControl>
        <FormControl
          label="Include in add to unlock goal"
          info="The one tick product amount will count towards Add To Unlock reward goals."
          withSwitch={[context, "settings.one_check_up_sell.include_in_atu"]}
        >
          <div></div>
        </FormControl>
        <FormControl label="Text">
          <RichEditor
            placeholder="Enter your sold here!"
            BindToContext={[context, "settings.one_check_up_sell.text"]}
            indicator="You can use {{title}} {{price}}"
          />
        </FormControl>
        <FormControl
          error={validationErrors["settings.one_check_up_sell.highlight"]}
        >
          {/*label="Highlight color" */}
          <ColorPicker
            text="Highlight color"
            BindToContext={[context, "settings.one_check_up_sell.highlight"]}
          />
        </FormControl>

        <FormControl label="Limit product name length">
          <Input
            // onFocus={() => setEditingProductDetails(true)}
            // onBlur={() => setEditingProductDetails(false)}
            type="number"
            placeholder="Characters length"
            BindToContext={[
              context,
              "settings.one_check_up_sell.truncate_length"
            ]}
            withSwitch={[context, "settings.one_check_up_sell.truncate"]}
          />
        </FormControl>

        <FormControl
          label="Product"
          error={
            validationErrors["settings.one_check_up_sell.product.variants"]
          }
          info={`Choose the product you want tick box to add to the cart.${!BREAK_POINTS["kill_draft"](shopContext)
            ? " Virtual products are invisible on your storefront, And existing products are not."
            : ""
            }`}
          isSingleCol
        >
          {!BREAK_POINTS["kill_draft"](shopContext) && (
            <ButtonSelect
              options={ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS}
              BindToContext={[
                context,
                "settings.one_check_up_sell.product_type"
              ]}
              first
              loading={[productsFetchLoading]}
            />
          )}
          <ShopifyResourcePicker
            allowMultiple={false}
            reducer={ONE_CHECK_UP_SELL_PRODUCT_REDUCER}
            BindToContext={[context, "settings.one_check_up_sell.product"]}
          >
            {(trigger) => (
              <Button
                className={classNames("w-full mt-3")}
                text="Select a product"
                type={
                  validationErrors[
                    "settings.one_check_up_sell.product.variants"
                  ] &&
                    !!validationErrors[
                    "settings.one_check_up_sell.product.variants"
                    ][0]
                    ? "danger"
                    : "primary"
                }
                onClick={() => {
                  switch (campaign.settings.one_check_up_sell.product_type) {
                    case "existing":
                      return trigger();
                    case "hidden":
                      return setShowHiddenProductSelector(true);
                  }
                }}
              />
            )}
          </ShopifyResourcePicker>
        </FormControl>
        <FormControl>
          <Summary campaign={context.state} />
        </FormControl>
      </FormGroup>
      <Modal
        visible={showHiddenProductSelector}
        title="Select Hidden product"
        onClose={() => setShowHiddenProductSelector(false)}
      >
        {(close, setTitle) => (
          <Carousel
            onChange={(tab) =>
              setTitle(
                tab === 0
                  ? "Select a hidden product"
                  : "Create a hidden product"
              )
            }
            contents={[
              (setActiveTab) => (
                <FormControl label="Hidden Products">
                  <ProductSelector
                    reducer={ONE_CHECK_UP_SELL_PRODUCT_REDUCER}
                    products={hiddenProducts}
                    BindToContext={[
                      context,
                      "settings.one_check_up_sell.product"
                    ]}
                    showCreate={() => setActiveTab(1)}
                  />
                </FormControl>
              ),
              <Fragment>
                <FormControl label="select example product">
                  <ProductSelector
                    presets={true}
                    reducer={ONE_CHECK_UP_SELL_PRODUCT_REDUCER}
                    products={PRESET_HIDDEN_PRODUCTS}
                    // BindToContext={[context, 'settings.one_check_up_sell.product']}
                    onChange={setProps}
                  // showCreate={() => setActiveTab(1)}
                  />
                </FormControl>
                <FormControl label="image">
                  <ImagePicker
                    // type="image"
                    value={productImage}
                    onChange={setProductImage}
                  />
                </FormControl>
                <FormControl label="Title">
                  <Input
                    placeholder="Gift Wrapping"
                    value={productTitle}
                    onChange={setProductTitle}
                  />
                </FormControl>
                <FormControl label="Price">
                  <Input
                    placeholder="Price"
                    type="number"
                    value={productPrice}
                    onChange={setProductPrice}
                  />
                </FormControl>
                <FormControl label="Description">
                  <RichEditor
                    placeholder="Description"
                    value={bodyHtml}
                    onChange={setBodyHtml}
                  />
                </FormControl>
              </Fragment>
            ]}
            controlsPosition="bottom"
            active={0}
            controls={[
              {
                text: "Close",
                type: "secondary",
                current: 0,
                next: () => close()
              },
              {
                text: hiddenProducts.length ? "Cancel" : "Close",
                type: "secondary",
                current: 1,
                next: (setActiveTab) =>
                  hiddenProducts.length ? setActiveTab(0) : close()
              },
              {
                text: "Create",
                loading: newHiddenProductLoading,
                current: 1,
                disabled:
                  productImage === "" ||
                  productTitle === "" ||
                  productPrice === "" ||
                  bodyHtml === "",
                next: (setActiveTab) => createProduct(setActiveTab)
              }
            ]}
          />
        )}
      </Modal>
    </>
  );
};

export default OneCheckUpSell;

const Summary = ({ campaign }) => {
  const {
    target,
    settings: { one_check_up_sell }
  } = campaign;
  const { product } = one_check_up_sell;
  if (!Object.keys(product || {}).length) return null;
  if (
    (target.type === "specific_products" && !target.selected.length) ||
    !product
  )
    return null;
  const must_truncated = (text) => text.length > 25;
  const truncate_name = (text) =>
    `"${text.substring(0, 25).trim()}${must_truncated(text) ? "..." : ""}"`;
  const product_name =
    target.type === "specific_products"
      ? truncate_name(target.selected[0].title)
      : "any product";
  if (!product.title) return null;

  return (
    <Alert type="info" icon="info-circle" title="campaign summary">
      <p>
        {`If ${product_name} is on the cart, Then you can add "${product.title
          .substring(0, 25)
          .trim()}
					${must_truncated(product.title) ? "..." : ""}" with one tick.`}
      </p>
    </Alert>
  );
};
